import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../firebase";
import { useTheme } from "./ThemeContext";
import { IconSearch, IconBrain, IconGlobe, IconFileText, IconShield, IconEdit, IconSun, IconMoon } from "./Icons";

export default function Login() {
  const { isDark, toggleTheme } = useTheme();

  const handleLogin = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
    } catch (err) {
      console.error("Login error:", err);
    }
  };

  return (
    <div className="login-page">
      <div className={`login-glow ${isDark ? "login-glow-dark" : "login-glow-light"}`} />

      {/* Theme toggle — top right */}
      <button className="login-theme-toggle" onClick={toggleTheme} title={isDark ? "Switch to light mode" : "Switch to dark mode"}>
        {isDark ? <IconSun size={16} color="var(--text-tertiary)" /> : <IconMoon size={16} color="var(--text-tertiary)" />}
      </button>

      <div className="login-card">
        <div className="login-logo-circle">
          <IconSearch size={26} color="var(--accent-text)" />
        </div>
        <h1 className="login-title">Cove</h1>
        <p className="login-sub">
          Multi-agent AI research with verified citations.
          <br />
          No hallucinations. Every source checked.
        </p>

        <div className="login-features">
          {[
            [IconBrain, "Orchestrator breaks down your query"],
            [IconGlobe, "Search agent finds real sources"],
            [IconFileText, "Summarizer extracts key claims"],
            [IconShield, "Verifier checks every citation"],
            [IconEdit, "Report writer compiles findings"],
          ].map(([Icon, text], i) => (
            <div key={i} className="login-feature">
              <div className="login-feature-icon">
                <Icon size={15} color="var(--accent-light)" />
              </div>
              <span>{text}</span>
            </div>
          ))}
        </div>

        <button className={`login-btn ${isDark ? "login-btn-dark" : "login-btn-light"}`} onClick={handleLogin}>
          <svg width="18" height="18" viewBox="0 0 48 48" style={{ marginRight: 10, flexShrink: 0 }}>
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.28-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          Continue with Google
        </button>
      </div>
    </div>
  );
}